import { gql } from '@apollo/client';

export const GetEljurOAuthLinkQuery = gql`
    query GetEljurOAuthLink($regionalCenterId: ID!, $authUrl: String!, $backUrl: String!) {
        getEljurOAuthLink(regionalCenterId: $regionalCenterId, authUrl: $authUrl, backUrl: $backUrl)
    }
`;
